export const isInvalidYear = (date: string) => {
  const year = date.split("/")[2];
  const currentYear = new Date().getFullYear();
  return Number(year) < 1900 || Number(year) > currentYear;
};
